export const IMAGES = {
  logo: "/assets/fastority-logo.jpg",
  mockupSos: "/assets/mockup-sos.webp",
  mockupMap: "https://static.prod-images.emergentagent.com/jobs/b43a1dae-2447-430e-89b9-b4a4d80e86b8/images/a78ca6a1ad548f93f329004e5ee70bc2ecde276e3f8a6153bd228caad1a33d75.jpeg",
  mockupAlert: "https://static.prod-images.emergentagent.com/jobs/b43a1dae-2447-430e-89b9-b4a4d80e86b8/images/48bd2c9058b956031c14b660f277982cc2a1c022b672844b6b7cef7ca734c324.jpeg",
  founder: "/assets/founder-michel.jpg",
  b2bProfessional: "https://images.unsplash.com/photo-1708807472445-d33589e6b090?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const USE_CASE_IMAGES = {
  "night-walk": "https://images.unsplash.com/photo-1530172888244-f3520bbeaa55?crop=entropy&cs=srgb&fm=jpg&q=85",
  "outdoor-sport": "https://images.unsplash.com/photo-1530143311094-34d807799e8f?crop=entropy&cs=srgb&fm=jpg&q=85",
  "child-safety": "https://images.unsplash.com/photo-1606474226448-4aa808468efc?crop=entropy&cs=srgb&fm=jpg&q=85",
  "expatriation": "https://images.unsplash.com/photo-1603792835233-f4f7c2497d4f?crop=entropy&cs=srgb&fm=jpg&q=85",
  "daily-commute": "https://images.unsplash.com/photo-1760279603529-471b946c4e0f?crop=entropy&cs=srgb&fm=jpg&q=85",
  "helping-others": "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const USE_CASE_SLUGS = [
  "night-walk",
  "outdoor-sport",
  "child-safety",
  "expatriation",
  "daily-commute",
  "helping-others",
];

export const PHONE_SCREENS = [
  "/assets/mockup-sos.webp",
  "/assets/screen-sos-choc.webp",
  "/assets/screen-alerter.webp",
  "/assets/screen-map2.webp",
  "/assets/screen-splash.webp",
  "/assets/screen-chat.webp",
];
